"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
exports.remove = ({ step, el, parentTimestamp, log, }) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
    const tagJsx = react_1.default.createElement("code", null,
        "<",
        el.tagName.toLowerCase(),
        " />");
    if (step.removeTarget === 'attributes') {
        const attrs = step.attributes
            .trim()
            .split(',')
            .map(s => {
            return s.trim();
        });
        const attrsRemoved = {};
        Array.from(el.attributes).map(a => {
            if (step.attributeRemovalStrategy === 'whitelist') {
                if (!attrs.includes(a.name)) {
                    attrsRemoved[a.name] = attrsRemoved[a.name]
                        ? attrsRemoved[a.name] + 1
                        : 0;
                    el.removeAttribute(a.name);
                }
            }
            else {
                if (attrs.includes(a.name)) {
                    attrsRemoved[a.name] = attrsRemoved[a.name]
                        ? attrsRemoved[a.name] + 1
                        : 0;
                    el.removeAttribute(a.name);
                }
            }
        });
        const attrsRemovedCount = Object.keys(attrsRemoved).length;
        if (attrsRemovedCount === 0) {
            log('warn', {
                message: (react_1.default.createElement(react_1.default.Fragment, null,
                    "No attributes found",
                    ' ',
                    step.attributeRemovalStrategy === 'whitelist'
                        ? 'that were not on whitelist'
                        : 'that were on blacklist',
                    ' ',
                    "on ",
                    tagJsx,
                    ".")),
                parentTimestamp,
            });
        }
        else {
            log('success', {
                message: (react_1.default.createElement(react_1.default.Fragment, null,
                    "Removed ",
                    attrsRemovedCount,
                    " attribute",
                    attrsRemovedCount === 1 ? '' : 's',
                    " that",
                    ' ',
                    step.attributeRemovalStrategy === 'whitelist'
                        ? 'were not on a whitelist'
                        : 'were on a blacklist',
                    ' ',
                    "from ",
                    tagJsx,
                    ". (",
                    Object.keys(attrsRemoved).join(', '),
                    ")")),
                parentTimestamp,
            });
        }
    }
    else {
        if (el.parentNode) {
            el.parentNode.removeChild(el);
            log('success', {
                message: react_1.default.createElement(react_1.default.Fragment, null,
                    "Removed ",
                    tagJsx,
                    "."),
                parentTimestamp,
            });
        }
        else {
            log('error', {
                message: react_1.default.createElement(react_1.default.Fragment, null,
                    "Could not remove ",
                    tagJsx,
                    "."),
                parentTimestamp,
            });
        }
    }
    return el;
});
//# sourceMappingURL=remove.js.map